import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase';
import { ref, get } from 'firebase/database';
import Header from '../components/Header';

const Profile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: '', text: '' });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      console.log(user);
      
      if (!user) {
        navigate('/login');
        return;
      }

      try {
        const userRef = ref(db, `users/${user.uid}`);
        const snapshot = await get(userRef);
        
        if (snapshot.exists()) {
          setUserData({ ...snapshot.val(), email: user.email });
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [navigate]);

  if (loading) {
    return (
      <>
        <Header />
        <div className="container mt-5 text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="card shadow-lg border-0">
              <div className="card-header  text-white p-4"
              style={{background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%) "}}>
                <h3 className="mb-0 text-white">
                  <i className="bi bi-person-circle me-2"></i>
                  My Profile
                </h3>
              </div>
              <div className="card-body p-4">
                {/* Success/Error Messages */}
                {message.text && (
                  <div className={`alert alert-${message.type === 'success' ? 'success' : 'danger'} alert-dismissible fade show`} role="alert">
                    <i className={`bi bi-${message.type === 'success' ? 'check-circle' : 'exclamation-triangle'}-fill me-2`}></i>
                    {message.text}
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setMessage({ type: '', text: '' })}
                      aria-label="Close"
                    ></button>
                  </div>
                )}

                <div className="text-center mb-4">
                  <div className="profile-avatar mx-auto mb-3">
                    <i className="bi bi-person-circle"></i>
                  </div>
                  <h4 className="fw-bold">{userData?.name}</h4>
                  <p className="text-muted">{userData?.email}</p>
                  <span className={`badge ${userData?.role === 'organizer' ? 'bg-warning text-dark' : 'bg-success'}`}>
                    {userData?.role?.charAt(0).toUpperCase() + userData?.role?.slice(1)}
                  </span>
                </div>

                <hr />

                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="info-card">
                      <i className="bi bi-person-fill text-primary"></i>
                      <div className="ms-3">
                        <small className="text-muted">Full Name</small>
                        <div className="fw-bold">{userData?.name || 'N/A'}</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="info-card">
                      <i className="bi bi-envelope-fill text-success"></i>
                      <div className="ms-3">
                        <small className="text-muted">Email</small>
                        <div className="fw-bold">{userData?.email || 'N/A'}</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="info-card">
                      <i className="bi bi-shield-fill text-warning"></i>
                      <div className="ms-3">
                        <small className="text-muted">Role</small>
                        <div className="fw-bold">{userData?.role || 'N/A'}</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="info-card">
                      <i className="bi bi-calendar-fill text-info"></i>
                      <div className="ms-3">
                        <small className="text-muted">Member Since</small>
                        <div className="fw-bold">
                          {userData?.createdAt 
                            ? new Date(userData.createdAt).toLocaleDateString()
                            : 'N/A'}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-4 text-center">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .bg-gradient {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }

        .profile-avatar {
          width: 120px;
          height: 120px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
        }

        .profile-avatar i {
          font-size: 5rem;
          color: white;
        }

        .info-card {
          display: flex;
          align-items: center;
          padding: 15px;
          background: var(--color-surface, #f8f9fa);
          border-radius: 10px;
          border: 1px solid var(--color-border, #dee2e6);
          transition: all 0.3s ease;
        }

        .info-card:hover {
          background: var(--color-border, #e9ecef);
          transform: translateY(-2px);
        }

        .info-card i {
          font-size: 1.5rem;
        }

        .info-card .fw-bold {
          color: var(--color-text, #212529);
        }

        [data-theme="dark"] .info-card {
          background: #2d2d44;
        }

        [data-theme="dark"] .info-card:hover {
          background: #3d3d5c;
        }

        [data-theme="dark"] .info-card .fw-bold {
          color: #e0e0e0;
        }

        [data-theme="dark"] .info-card .text-muted {
          color: #a0a0a0 !important;
        }

        .btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          transition: all 0.3s ease;
        }

        .alert {
          border-radius: 10px;
          border: none;
        }
      `}</style>
    </>
  );
};

export default Profile;